import { useState, useCallback } from 'react';
import { DEFAULT_COLORS, type ChatColors } from '@/contexts/ChatColorsContext';

const STORAGE_KEY = 'bozzetti_chat_colors';

function load(): ChatColors {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? { ...DEFAULT_COLORS, ...JSON.parse(raw) } : DEFAULT_COLORS;
  } catch {
    return DEFAULT_COLORS;
  }
}

export function useChatColorsStore() {
  const [colors, setColors] = useState<ChatColors>(load);

  const updateColors = useCallback((next: Partial<ChatColors>) => {
    setColors((prev) => {
      const updated = { ...prev, ...next };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const resetColors = useCallback(() => {
    setColors(DEFAULT_COLORS);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  return { colors, updateColors, resetColors };
}
